import { getCookie } from '@/utils/cookie';
import { useLocalStorage, useSessionStorage } from '@vueuse/core';

export function usePersonalLocalStorage(...args) {
  const isImitating = getCookie('imitation_token');
  return isImitating ? useSessionStorage(...args) : useLocalStorage(...args);
}
